<template>
<div :class="{'modal':true, 'is-active':show}">
  <div class="modal-background"></div>
  <div class="modal-content has-text-centered">
      <div class="loader-box">
          <div class="loader"></div>
      </div>
  </div>
</div>
</template>

<script>
export default {
    name:'Loader',
    props: {
        show: {
            type:Boolean,
            default:false
        }
    }
}
</script>

<style scoped>
    .modal-content {
        overflow: inherit;
    }
    .modal{
        z-index: 50 !important;
    }
</style>